<template>
  <v-app id="inspire">
    <v-app-bar
          app
          clipped-left
          color="green"
          dark
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title><v-icon>mdi-flash</v-icon> Green Server</v-toolbar-title>
        <v-spacer></v-spacer>
        

        <span style="font-size: .9em">
          <v-icon small class="mr-2">mdi-domain</v-icon>
          {{user.dealer.name}}
          <br> 
          <v-icon small class="mr-2">mdi-account</v-icon>
          {{user.user.name}} | {{user.role.name}}
          

        </span>
        <v-btn class="ml-3" color="green darken-2" @click="logout">
          <v-icon small>mdi-logout</v-icon>
          Выход
        </v-btn>
        <v-dialog
          v-model="editor"
          max-width="800px"
        >
          <!-- <SelfEditor @onCloseEdit="editor=false" /> -->
        </v-dialog>
        <!-- <span>{{ user.is_admin ? 'Администратор' : 'Пользователь' }}</span> -->
        
        <v-progress-linear
            absolute
            bottom
            color="green darken-3"
        />
      </v-app-bar>

      <v-navigation-drawer clipped app v-model="drawer">
        <!-- Панель навигации -->
        <v-list dense>
          <v-list-item link to="/gsa" exact>
            <v-list-item-avatar><v-icon>mdi-home-lightning-bolt</v-icon></v-list-item-avatar>
            <v-list-item-content>Список GSA</v-list-item-content>
          </v-list-item>
          <v-list-item link to="/gsa/new" exact>
            <v-list-item-avatar><v-icon>mdi-lightning-bolt</v-icon></v-list-item-avatar>
            <v-list-item-content>Добавить GSA</v-list-item-content>
          </v-list-item>
          <v-list-item link href="https://disk.yandex.ru" target="_blank" exact>
            <v-list-item-avatar><v-icon>mdi-open-in-new</v-icon></v-list-item-avatar>
            <v-list-item-content>Скачать GSA</v-list-item-content>
          </v-list-item>
          <v-list-item link href="https://wiki.carbis.ru" target="_blank" exact>
            <v-list-item-avatar><v-icon>mdi-open-in-new</v-icon></v-list-item-avatar>
            <v-list-item-content>Документация</v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <v-main style="position: relative;">
        <div class="d-flex flex-column fill-height">
          <v-banner dense style="background: #fff; position: sticky; top: 64px; z-index: 4;">
            <v-breadcrumbs style="padding: 0" divider=">" :items="breadcrumbs"/>
          </v-banner>
          <!-- <div class="px-8 py-4" style="background: #fff; position: sticky; top: 60px; z-index: 4;">Bread-crumbs</div> -->
          <div class="pa-2 flex-grow-1">
            <router-view  />
          </div>
        </div>
        
        <v-snackbar
          :timeout="5000"
          v-model="is_error_raised"
          color="red"
        >
          <v-icon>mdi-alert-circle-outline</v-icon>
          При загрузке данных возникла ошибка:<br><br>
          {{ `(${error.error_class}) ${error.error_text}` }}
        </v-snackbar>
        
        
      </v-main>
  </v-app>
</template>

<script>
  import {mapGetters} from 'vuex'
  // import SelfEditor from '../../components/editors/user/SelfEditor.vue'

  export default {
    name: 'User',
    data: () => ({
      editor: false,
      drawer: undefined
    }),
    components: {
      // SelfEditor
    },
    watch: {
      $route(to) {
        if (to.matched.reduce((prev, cur) => prev || cur.meta?.admin_only, false)) {
          this.$router.replace('/')
        }
       }
    },
    methods: {
      async logout() {
        this.$router.replace('/')
        await this.$store.dispatch('logout')
      },
    },
    computed: {
      ...mapGetters(['user', 'raised', 'error']),
      is_error_raised:{
        get(){
          return this.raised
        },
        set(v){
          this.$store.commit('raised', v)
        }
      },
      breadcrumbs(){
        return this.$route.matched.map(el => {
          return {'text': el.name}
        })
      }
    }
  }
</script>